import React from 'react';

import _ from 'lodash';
import cx from 'classnames';
import { Image } from 'react-bootstrap';

import styles from './responsiveDesign.module.scss'

export const DesignPreview = () => {
  return (
    <div className={styles.seekPreview}>
      <div className={styles.header}>
        <Image className={styles.banner} src={"/images/seekDesign/desktopHeader.png"} />
      </div>
      <div className={styles.previewContent}>
        
      </div>
    </div>
  )
}